import React, { useState, useEffect, useCallback } from 'react';
import { withAppHOC } from '../../../hoc';
import PageHeading from '../../../components/PageHeader/PageHeader';
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader';
import { Grid, GridItem } from '../../../components/Grid';
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  Dropdown,
  MessageBox,
  CreateButton,
  ResetButton,
  Textarea,
  TextInput,
} from '../../../components/FormElements';
import API from '../../../api';
import {
  API_RESPONSE_TYPES,
  MODULES,
  PERMISSION_TYPES,
} from '../../../constants';
import { camelCaseToString, authData } from '../../../utils';

const SendNotifications = (props) => {
  // const { accountsPermissions } = authData.get();
  // const hasPushNotifications =
  //   accountsPermissions[MODULES.PUSH_NOTIFICATIONS] &&
  //   accountsPermissions[MODULES.PUSH_NOTIFICATIONS].includes(
  //     PERMISSION_TYPES.CREATE
  //   )
  //     ? true
  //     : false;
  const hasPushNotifications = false;
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [rolesId, setRolesId] = useState('');
  const [usersId, setUsersId] = useState('');
  const [notificationType, setNotificationType] = useState(
    hasPushNotifications ? '' : 'Others'
  );
  const [sms, setSms] = useState(false);
  const [email, setEmail] = useState(false);
  const [whatsapp, setWhatsapp] = useState(true);
  const [telegram, setTelegram] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  const resetForm = () => {
    setRolesId('');
    setUsersId('');
    setNotificationType('');
    setSms(false);
    setEmail(false);
    setWhatsapp(false);
    setTelegram(false);
    setTitle('');
    setMessage('');
  };

  // const readRoles = useCallback(() => {
  //   setIsLoading(true);
  //   setResponseStatus("");
  //   setResponseMessage("");
  //   API.get("/accounts-management/roles-and-permissions")
  //     .then((response) => {
  //       const { status, message, data } = response.data;
  //       if (status === API_RESPONSE_TYPES.FAILURE) {
  //         setResponseStatus(status);
  //         setResponseMessage(message);
  //       } else {
  //         setRoles(data);
  //       }
  //     })
  //     .catch((error) => {
  //       setResponseStatus(API_RESPONSE_TYPES.FAILURE);
  //       setResponseMessage(error.message);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // }, []);

  const readUsers = useCallback(() => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get('/accounts-management/users')
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILURE) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setUsers(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    const formData = {
      // rolesId: rolesId,
      usersId: usersId,
      notificationType: notificationType,
      sms: sms ? 'Yes' : 'No',
      email: email ? 'Yes' : 'No',
      whatsapp: whatsapp ? 'Yes' : 'No',
      telegram: telegram ? 'Yes' : 'No',
      title: title,
      message: message,
    };
    API.post('/configurations/send-notifications', formData);
    setIsLoading(false);
    setResponseStatus(API_RESPONSE_TYPES.SUCCESS);
    setResponseMessage('Your request is being processed');
    setTimeout(() => {
      setResponseStatus('');
      setResponseMessage('');
    }, 3000);
  };

  useEffect(() => {
    // readRoles();
    readUsers();
  }, [
    //readRoles,
    readUsers,
  ]);

  // const rolesOptions = [{ title: "-- SELECT ROLE --", value: "" }];
  // roles.forEach(({ id, roleName }) =>
  //   rolesOptions.push({
  //     title: camelCaseToString(roleName),
  //     value: id,
  //   })
  // );

  const usersOptions = [{ title: '-- SELECT USER --', value: '' }];
  users
    // .filter(({ accountsRolesId }) =>
    //   rolesId !== "" ? accountsRolesId === rolesId : true
    // )
    .forEach(({ id, fullName }) =>
      usersOptions.push({
        title: fullName,
        value: id,
      })
    );

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          <Fieldset>
            <Label>User</Label>
            <Dropdown
              placeholder="Please select user"
              value={usersId}
              onChange={setUsersId}
              options={usersOptions}
              disabled={isLoading}
            />
          </Fieldset>
          {/* {hasPushNotifications && (
            <Fieldset>
              <Label required>Notification Type</Label>
              <Dropdown
                placeholder="Please select notification type"
                value={notificationType}
                onChange={setNotificationType}
                options={[
                  {
                    title: "-- SELECT NOTIFICATION TYPE --",
                    value: "",
                  },
                  {
                    title: "Push Notification",
                    value: "Push Notification",
                  },
                  {
                    title: "Others",
                    value: "Others",
                  },
                ]}
                disabled={isLoading}
              />
            </Fieldset>
          )} */}
          {/* {notificationType === "Others" && (
            <Fieldset>
              <Label required>Notification Medium</Label>
              <Grid
                columns={
                  "calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)"
                }
              >
                <GridItem>
                  <Fieldset style={{ padding: "20px 0px", margin: "0px" }}>
                    <input
                      type="checkbox"
                      value={sms}
                      id="sms"
                      onChange={(e) => setSms(e.target.checked)}
                    />
                    <Label htmlFor="sms" style={{ display: "inline" }}>
                      SMS
                    </Label>
                  </Fieldset>
                </GridItem>
                <GridItem>
                  <Fieldset style={{ padding: "20px 0px", margin: "0px" }}>
                    <input
                      type="checkbox"
                      value={email}
                      id="email"
                      onChange={(e) => setEmail(e.target.checked)}
                    />
                    <Label htmlFor="email" style={{ display: "inline" }}>
                      Email
                    </Label>
                  </Fieldset>
                </GridItem>
                <GridItem>
                  <Fieldset style={{ padding: "20px 0px", margin: "0px" }}>
                    <input
                      type="checkbox"
                      value={whatsapp}
                      id="whatsapp"
                      onChange={(e) => setWhatsapp(e.target.checked)}
                    />
                    <Label htmlFor="whatsapp" style={{ display: "inline" }}>
                      Whats App
                    </Label>
                  </Fieldset>
                </GridItem>
                <GridItem>
                  <Fieldset style={{ padding: "20px 0px", margin: "0px" }}>
                    <input
                      type="checkbox"
                      value={telegram}
                      id="telegram"
                      onChange={(e) => setTelegram(e.target.checked)}
                    />
                    <Label htmlFor="telegram" style={{ display: "inline" }}>
                      Telegram
                    </Label>
                  </Fieldset>
                </GridItem>
              </Grid>
            </Fieldset>
          )} */}
          {/* {notificationType === "Push Notification" && (
            <Fieldset>
              <Label required>Title</Label>
              <TextInput
                placeholder="Please enter title"
                value={title}
                onChange={setTitle}
                disabled={isLoading}
              />
            </Fieldset>
          )} */}
          {notificationType && (
            <Fieldset>
              <Label required>Message</Label>
              <Textarea
                placeholder="Please enter message"
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value);
                }}
                disabled={isLoading}
              />
            </Fieldset>
          )}
          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <CreateButton disabled={isLoading === true} type="submit">
              Send
            </CreateButton>
            <ResetButton
              disabled={isLoading === true}
              type="button"
              onClick={resetForm}
            >
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(SendNotifications);
